import React from 'react'
import PropTypes from 'prop-types'
import _ from "lodash"
import { useFormContext } from 'react-hook-form'
//************************************//
import InputContainer from "@src/components/helpers/InputContainer"
import CustomFormGroup from "@src/components/helpers/CustomFormGroup"
import { trans } from '@utils'
//************************************//

const Email = props => {
  const { data } = props
  const { register } = useFormContext()

  return (
    <CustomFormGroup
      title={trans('customFields.useAsNotificationRecipient')}
      tooltip={trans('customFields.useAsNotificationRecipientTooltip')}
      name={`${data.key}-is_notification_recipient`}
    >
      <InputContainer
        id={`${data.key}-is_notification_recipient`}
        type={'checkbox'}
        name={'config.is_notification_recipient'}
        defaultChecked={!!_.get(data, 'config.is_notification_recipient', false)}
        innerRef={register()}
      />
    </CustomFormGroup>
  )
}

Email.propTypes = {}

export default Email